import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManualBackofficePage } from './manual-backoffice.page';

const routes: Routes = [
  {
    path: '',
    component: ManualBackofficePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManualBackofficePageRoutingModule {}
